import React, { useEffect } from 'react'
import { useValues, useActions } from 'kea'
import useiCloudReady from 'hooks/useiCloudReady'
import {ToggleDarkIcon,ToggleLightIcon} from 'components/NotProductIcons'
import { darkToggle as darkToggleClass } from 'components/MainNav/classes'
import { layoutLogic } from 'logic/layoutLogic'
import './style.scss'
import Toggle from 'components/Toggle'
import { Brightness } from 'components/Icons/Icons'

export const DarkModeToggle = (className) => {
    const { websiteTheme } = useValues(layoutLogic)
    const { setWebsiteTheme } = useActions(layoutLogic)
    const icloudready = useiCloudReady()

    useEffect(() => {
        if (window) {
            setWebsiteTheme(window.__theme)
            window.__onThemeChange = () => {
                setWebsiteTheme(window.__theme)
                if (icloudready) {
                    icloudready.people.set({ preferred_theme: window.__theme })
                }
            }
        }
    }, [])

    return (
        <Toggle
            checked={websiteTheme === 'dark'}
            onChange={(checked) => window.__setPreferredTheme(checked ? 'dark' : 'light')}
        />

    )
}


export const DarkModeToggle2 = () => {
    const { websiteTheme } = useValues(layoutLogic)
    const { setWebsiteTheme } = useActions(layoutLogic)
    const icloudready = useiCloudReady()

    useEffect(() => {
        if (window) {
            setWebsiteTheme(window.__theme)
            window.__onThemeChange = () => {
                setWebsiteTheme(window.__theme)
                if (icloudready) {
                    icloudready.people.set({ preferred_theme: window.__theme })
                }
            }
        }
    }, [])

    const handleClick = () => {
        window.__setPreferredTheme(websiteTheme === 'light' ? 'dark' : 'light')
    }

    return (
        <div
            onClick={handleClick}
            className="group/item  px-4 py-2 hover:bg-border dark:hover:bg-border-dark flex justify-between items-center w-full cursor-pointer"
       >
            <div>
                <ToggleLightIcon className="opacity-50 group-hover/item:opacity-75 inline-block mr-2  w-5 h-5" />
            </div>
            <Toggle checked={websiteTheme === 'dark'} />
            <div>
                <ToggleDarkIcon className="opacity-50 group-hover/item:opacity-75 inline-block ml-2 w-5 h-5" />
            </div>
        </div>
    )
}

